module.exports = __webpack_public_path__ + "img/roseiral_02.3340e08d.jpg";